import ServiceBase from "base/baseService"

export default class TipoTributoService extends ServiceBase {

    title = "Tipo de tributo"
    pluralTitle = "Tipos de tributo"
    url = '/cadastro/fiscal/tipo_tributo'
    frontUrl = '/cadastro/fiscal/tipotributo'
    frontUrlList = '/cadastro/fiscal/tipotributolist'
    primaryKey = 'codigo_tiptri'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {
        data.descricao_tiptri = data?.descricao_tiptri || ''
        return data
    }

    prepareToSave({ data }) {
        if ('meta' in data) delete data.meta
        return data
    }

}
